export const OrderUti = {
  status: (
    value: number
  ): 'idle' | 'delivery' | 'ready' | 'accepted' | 'cancelled' => {
    switch (value) {
      case 1:
        return 'idle';
      case 2:
        return 'idle';
      case 3:
        return 'ready';
      case 4:
        return 'delivery';
      case 5:
        return 'accepted';
      case 9:
        return 'cancelled';
      default:
        return 'idle';
    }
  },
};
